import { defaultTheme } from '@antlerengineering/components';

export default defaultTheme;
